// src/pages/EmployerTraining.jsx
import { useState, useEffect, useMemo } from "react";
import { auth, db, storage } from "../firebase/config";
import { collection, getDocs, getDoc, doc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";
import TrainingTabs from "../components/TrainingTabs";
import AssignTrainingSection from "../components/AssignTrainingSection";
import TrainingLibrarySection from "../components/TrainingLibrarySection";
import TrainingTracker from "../components/TrainingTracker"; // 👈 NEW
import "../styles/EmployerTraining.css";
import "react-toastify/dist/ReactToastify.css";

export default function EmployerTraining() {
  const [companyId, setCompanyId] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [trainingCourses, setTrainingCourses] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [companyTimeZone, setCompanyTimeZone] = useState("UTC");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) return;

      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) return;

      const cid = userDoc.data().companyId;
      setCompanyId(cid);

      const companyDoc = await getDoc(doc(db, "companies", cid));
      setCompanyTimeZone(companyDoc.data()?.timeZone || "UTC");

      const empSnap = await getDocs(
        collection(db, `companies/${cid}/employees`)
      );
      setEmployees(empSnap.docs.map((d) => ({ id: d.id, ...d.data() })));

      const courseSnap = await getDocs(
        collection(db, `companies/${cid}/training_courses`)
      );
      setTrainingCourses(
        courseSnap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
    });

    return () => unsubscribe();
  }, []);

  const defaultThumbnailUrl =
    "https://firebasestorage.googleapis.com/v0/b/employee-b47f3.firebasestorage.app/o/thumbnails%2Fpexels-ron-lach-8100074.jpg?alt=media&token=c6cdf2fb-ac5e-4d45-8171-8634b1d34356";

  const tabs = useMemo(
    () => ({
      library: {
        label: "Training Library",
        content: (
          <TrainingLibrarySection
            db={db}
            storage={storage}
            companyId={companyId}
            companyTimeZone={companyTimeZone}
            defaultThumbnailUrl={defaultThumbnailUrl}
            trainingCourses={trainingCourses}
            setTrainingCourses={setTrainingCourses}
          />
        ),
      },
      assign: {
        label: "Assign Training",
        content: (
          <AssignTrainingSection
            companyId={companyId}
            employees={employees.filter((e) => e.status === "Active")}
            trainingCourses={trainingCourses}
            setTrainingCourses={setTrainingCourses}
            selectedEmployee={selectedEmployee}
            setSelectedEmployee={setSelectedEmployee}
          />
        ),
      },
      tracker: {
        label: "Training Tracker",
        // 👇 pass data so the tracker doesn't re-fetch the same things
        content: (
          <TrainingTracker
            companyId={companyId}
            companyTimeZone={companyTimeZone}
            initialEmployees={employees}
          />
        ),
      },
    }),
    [companyId, companyTimeZone, trainingCourses, employees, selectedEmployee]
  );

  return (
    <div className="Training-title-container">
      <div className="training-wrapper">
        <TrainingTabs tabs={tabs} />
        <ToastContainer />
      </div>
    </div>
  );
}
